import { createRouter, createWebHistory } from 'vue-router';
import QrPage from '@/components/QrPage.vue';

const routes = [
    {
        path: '/:uuid',
        name: 'QrPage',
        component: QrPage,
        // // 你可以在这里添加meta字段来存储一些额外的信息，比如默认的标题或者标题的生成逻辑
        // meta: {
        //     // 假设我们有一个默认的标题，或者你可以在这里编写一个函数来根据data生成标题
        //     defaultTitle: `${this.$store.state.id}`
        // }
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});
// 使用路由守卫来修改页面标题
router.beforeEach((to, from, next) => {
    if (to.name === 'QrPage') {
        // 假设你想根据 uuid 或其他逻辑来设置标题
        // 但由于你不能直接从 meta 获取动态标题，我们在这里直接根据 uuid 设置一个示例标题
        // const uuid = to.params.uuid || to.query.uuid || 'default-uuid'; // 注意：这里假设 uuid 是查询参数，如果它是路径参数且未配置嵌套路由，则这种方式无法直接获取
        // 如果你确实需要根据 store 中的数据来设置标题，你可以这样做：
        const id=to.query.id
        const createdTime=to.query.createdTime
        document.title = `${id}的护耳报告${createdTime}`; // 但请注意，这里的 id 应该与 uuid 逻辑分开处理
    }
    next();
});
export default router;
